import { render, staticRenderFns } from "./feeDiscountManageList.vue?vue&type=template&id=b836f8f6&scoped=true"
import script from "./feeDiscountManageList.vue?vue&type=script&lang=js"
export * from "./feeDiscountManageList.vue?vue&type=script&lang=js"
import style0 from "./feeDiscountManageList.vue?vue&type=style&index=0&id=b836f8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b836f8f6",
  null
  
)

export default component.exports